import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export const StatBlock = ({ label, value, hint }) => (
  <div className="card-surface p-5">
    <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">{label}</div>
    <div className="font-display text-3xl mt-2">{value}</div>
    {hint && <div className="text-xs text-zinc-500 mt-1">{hint}</div>}
  </div>
);

export function ConfirmButton({ label, description, onConfirm, variant = "default", testid, children }) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          size="sm"
          data-testid={testid}
          className={`rounded-none text-xs ${
            variant === "danger"
              ? "bg-rose-600 hover:bg-rose-700 text-white"
              : "bg-transparent border border-white/15 text-white hover:border-rose-600"
          }`}
        >
          {children}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="rounded-none bg-zinc-950 border-white/10">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl">{label}</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-none bg-transparent border border-white/15 text-white hover:bg-white/5">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="rounded-none bg-rose-600 hover:bg-rose-700 text-white"
            data-testid={testid ? `${testid}-confirm` : undefined}
          >
            Confirm
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${Math.floor(s)}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
}
